import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIcon } from '@angular/material/icon';
import { MatPaginator, MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { TiretPipe } from 'src/app/pipe/tiret.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { ProfilUtilisateurService } from 'src/services/profil-utilisateur.service';
import { UtilisateurService } from 'src/services/utilisateur.service';
import { DocumentUtilisateurModel } from 'src/models/profil-utilisateur/document-utilisateur-model';
import { CustomPaginatorIntlService } from 'src/services/custom-paginator-intl.service';


@Component({
    selector: 'app-list-document',
    templateUrl: './list-document.component.html',
    styleUrls: ['./list-document.component.scss'],
    imports: [
    MatIcon,
    FormsModule,
    TranslateModule,
    MatCheckboxModule,
    MatProgressSpinner,
    MatTableModule,
    MatPaginator,
    MatSortModule,
    MatButtonModule,
    TiretPipe
],
    providers: [
        {
            provide: MatPaginatorIntl,
            useClass: CustomPaginatorIntlService
        }
    ]
})
export class ListDocumentComponent implements OnInit {
  estPiloteOuAdmin!: boolean;
  entiteId!: number;
  afficherSectionAjouterDocument!: boolean;
  isLoading!: boolean;
  language!: 'FR' | 'EN' | 'ES';
  nom = '';
  file: File | null = null;
  estVisible: boolean = false;
  fileExtension!: string;
  subtitleFile: File | null = null;
  description = '';
  contentType: 'pdf' | 'doc' | 'docx' | 'xls' | 'xlsx' = 'pdf';
  utilisateurId!: number;

  displayedColumns: string[] = [
    'nomFichier',
    'description',
    'nomUtilisateur',
    'extension',
    'actions'
  ];

  pageIndex: number = 0;
  pageSize: number = 10;
  currentPage: number = 0;
  totalItems: number = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  textFilter: string = '';
  textRechercher: string = "";
  isFiltering: boolean = false;

  dataSource!: MatTableDataSource<DocumentUtilisateurModel>;
  documents: DocumentUtilisateurModel[] = [];
  documentsEncours: DocumentUtilisateurModel[] = [];

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  isDragging = false;
  fileError = '';
  constructor(private location: Location,
    private changeDetectorRef: ChangeDetectorRef,
    private utilisateurServicePilotage: UtilisateurService,
    private profilUtilisateurService: ProfilUtilisateurService
  ) {
    this.dataSource = new MatTableDataSource<DocumentUtilisateurModel>([]);
  }

  ngOnInit() {
    this.estPiloteOuAdmin = this.utilisateurServicePilotage.estRolePiloteOuAdmin();
    this.entiteId = this.utilisateurServicePilotage.selectionEntiteUtilisateur.entiteUtilisateurs[0].entiteId;
    this.utilisateurId = this.utilisateurServicePilotage.selectionEntiteUtilisateur.entiteUtilisateurs[0].utilisateurId;
    this.obtenirDocumentUtilisateur(this.utilisateurId, this.estPiloteOuAdmin);
  }

  ngAfterViewInit() {
    if (this.sort) {
      this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && !changes['data'].firstChange) {
      this.totalItems = this.documents.length;
      this.refreshDataSource();
    }
  }

  paginer(event?: PageEvent) {
    if (event) {
      this.pageIndex = event.pageIndex;
      this.pageSize = event.pageSize;
    }
    const startIndex = this.pageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;

    const paginatedData = this.documentsEncours.slice(startIndex, endIndex);
    this.dataSource.data = paginatedData;
    this.changeDetectorRef.detectChanges();
  }

  sortDataChange(sortState: Sort) {
    if (sortState.direction) {
      this.dataSource.sort = this.sort;
    }
  }


  filtre(): void {
    if (this.isFiltering) return;
    this.isFiltering = true;

    try {
      this.applyFilters();

    } finally {
      this.isFiltering = false;
    }
  }


  filtreRecherche(): void {
    if (this.textRechercher) {
      const textRechercher = this.textRechercher.trim().toLowerCase();
      this.documentsEncours = this.documents.filter(contenu => {
        const checkValue = (value: any): boolean => {
          if (value && typeof value === 'object') {
            return Object.values(value).some(v => checkValue(v));
          }
          return value && String(value).toLowerCase().includes(textRechercher);
        };

        return Object.values(contenu).some(value => checkValue(value));
      });
    } else {
      this.documentsEncours = [...this.documents];
    }
  }

  private applyFilters(): void {
    this.documentsEncours = this.documents;
    this.filtreRecherche();
    this.totalItems = this.documentsEncours.length;

    this.pageIndex = 0;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }

    this.paginer();
  }

  private updatePaginatorLength(): void {
    if (this.paginator) {
      this.paginator.length = this.totalItems;
      this.changeDetectorRef.detectChanges();
    }
  }

  refreshDataSource(): void {
    this.documentsEncours = this.documents;
    this.dataSource.data = this.documentsEncours;
    this.updatePaginatorLength();
  }

  obtenirDocumentUtilisateur(entiteId: number, adminOuPilote: boolean) {
    this.profilUtilisateurService.obtenirDocumentUtilisateur(entiteId, adminOuPilote).subscribe((reponse) => {
      this.afficherSectionAjouterDocument = false;
      this.isLoading = false;
      this.documents = reponse;
      this.applyFilters();
    });
  }

  visualiser(documentUtilisateur: DocumentUtilisateurModel) {
    this.profilUtilisateurService.obtenirDocument(documentUtilisateur.documentId).subscribe(({ blob, contentType }) => {
      if (contentType === 'application/pdf') {
        this.ouvrirRapportOnglet(blob, contentType!);
      } else {
        this.telechargerDocument(blob, documentUtilisateur.extension, documentUtilisateur.nomFichier)
      }
    });
  }

  ouvrirRapportOnglet(reponse: Blob, type: string) {
    var newBlob: Blob;
    newBlob = new Blob([reponse], { type: type });
    const fileURL = URL.createObjectURL(newBlob);
    window.open(fileURL, '_blank');
  }

  telechargerDocument(blob: Blob, extension: string, nom: string) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${nom}${extension}`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  annuler(): void {
    this.location.back();
  }


  retour(): void {
    this.location.back();
  }
}
